import * as React from "react";
import LinearProgress from "@mui/material/LinearProgress";

declare const window: any;

export default function CardV2({ intro, progress }: any) {
    React.useEffect(() => {
        // Aquí puedes definir el color de fondo de la clase intro-cardv2-load-bar
        const loadBar: any = document.querySelector('.intro-cardv2-load-bar');
        if (loadBar) {
            loadBar.style.backgroundColor = '#fff';
        }

        // Aquí puedes definir el color de fondo del span dentro del componente
        const spanElement: any = document.querySelector('.intro-cardv2-load-bar span');
        if (spanElement) {
            spanElement.style.backgroundColor = intro?.colors?.main_buttons; // Puedes ajustar el color que desees aquí
        }
    }, [intro?.colors?.main_buttons]);
    
  return (
    <div className="intro-cardv2-container-wrapper">
      <div className="intro-cardv2-container">
        <div className="intro-cardv2-logos">
          <img
            src={`${window.hybrid ? "./" : "https://d1bsymnertnea6.cloudfront.net/" }galleries/${window?.builder_id}/logo.svg`}
            alt=""
          />
          <img
            src={`${window.hybrid ? "./" : "https://d1bsymnertnea6.cloudfront.net/" }galleries/${window?.builder_id}/${window?.project_id}/logo.svg`}
            alt=""
          />
        </div>
        {
            progress !== 100 ? 
            <div className="intro-cardv2-load">
              <span>Cargando...</span>
              <LinearProgress variant="determinate" className="intro-cardv2-load-bar" value={progress} />
              <p>{progress}%</p>
            </div>
            :
            <div className="intro-cardv2-ingresar" style={{backgroundColor: intro?.colors?.main_buttons, color: intro?.colors?.secondary_text}}>Ingresar</div>
        }
        <div className="intro-cardv2-poweredBy">
          Powered by ® Umbra Group - 2025
        </div>
      </div>
    </div>
  );
}
